import { CoveragePlanGetResponse } from '@cms-max/medicare-api-sdk'
import { medicareApiClient } from 'clients/medicareApiClient'
import { useQuery } from 'react-query'

export const usePlansQuery = () => {
  const fetchPlans = async () => {
    return await medicareApiClient.asyncGetPlans()
  }

  return useQuery<CoveragePlanGetResponse | undefined>('plans', fetchPlans)
}
